import { useSelector } from 'react-redux';
import { Roles } from 'modules/core/enums';
import { getUser } from 'store/selectors/auth.selector';
import { getFeaturesList } from 'store/selectors/ui.selector';
import { getLenderState } from 'store/selectors/lenders.selector';

export function useSettingsFieldsRulesForLender() {
  const user = useSelector(getUser);
  const features = useSelector(getFeaturesList);
  const lender = useSelector(getLenderState);

  const isSalesperson = user?.role === Roles.SALESPERSON;
  const isSbbPlusEnabled = !!lender?.isShopByBudgetEnabled;
  const isSbcPlusEnabled = !!lender?.isShopByCallbackEnabled;
  const isRouteOneBlank = !lender?.route_one_id;
  const isAnyBookApiEnabled = !!features?.vehicle_details_from_jdp || !!features?.kbb_api || !!features?.bb_api;
  const isTestModeOff = !features?.is_test_mode_enabled;
  const isTenantActive = !!features?.is_tenant_active;

  const enableLtvTaxesDropdown = (isSbbPlusEnabled || isSbcPlusEnabled) && isRouteOneBlank;
  const showVendorDropdown =
    (isSbbPlusEnabled || isSbcPlusEnabled) &&
    isRouteOneBlank &&
    isAnyBookApiEnabled &&
    isTestModeOff &&
    isTenantActive &&
    !isSalesperson;

  return {
    enableLtvTaxesDropdown,
    showVendorDropdown,
  };
}
